import { sanitizeArticleHtml } from '@/lib/article-html'

/**
 * Render an article's stored HTML through the ARTICLE sanitizer profile.
 *
 * The one renderer for article content: the composer's preview and the Brand
 * page's Brand details tab both go through it, which is what makes a reader see
 * exactly what the author produced. Never render article content any other way,
 * and never reach for `SafeHtml` instead — its allowlist drops headings and
 * cannot carry a swatch colour.
 */
export function SafeArticleHtml({ html, className }: { html: string; className?: string }) {
	const clean = sanitizeArticleHtml(html)
	// biome-ignore lint/security/noDangerouslySetInnerHtml: content is sanitized by sanitizeArticleHtml above
	return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />
}
